import JSZip from 'jszip';
import type { GraphArchivePackage } from '../../types/archive';
import type { GraphDocument } from '../../core/entities/graph-document';
import type { MediaManifest } from '../../core/entities/media-asset';
export async function parseJourneyNodesArchive(input: Blob | ArrayBuffer | Uint8Array): Promise<GraphArchivePackage> {
  const zip = await JSZip.loadAsync(input);
  const graphFile = zip.file('graph.json');
  const manifestFile = zip.file('media-manifest.json');
  if (!graphFile) throw new Error('Missing graph.json');
  if (!manifestFile) throw new Error('Missing media-manifest.json');
  const graphJson = JSON.parse(await graphFile.async('string')) as GraphDocument;
  const mediaManifest = JSON.parse(await manifestFile.async('string')) as MediaManifest;
  const assets: GraphArchivePackage['assets'] = {};
  const assetFiles = Object.values(zip.files).filter((file) => file.name.startsWith('assets/') && !file.dir);
  for (const file of assetFiles) assets[file.name.replace(/^assets\//, '')] = await file.async('uint8array');
  const configFile = zip.file('config.json');
  const savegameFile = zip.file('savegame.json');
  const signatureFile = zip.file('signature.json');
  return {
    graphJson,
    mediaManifest,
    assets,
    configJson: configFile ? JSON.parse(await configFile.async('string')) : undefined,
    savegameJson: savegameFile ? JSON.parse(await savegameFile.async('string')) : undefined,
    archiveSignature: signatureFile ? JSON.parse(await signatureFile.async('string')) : undefined,
  };
}
